import { SuccessMark } from '@webapp/common/assets/icons';

import css from '@webapp/landing/src/components/ru/docs/css/license.css';
import { DownloadButton } from '@webapp/landing/src/components/ui/download-button';

export const License: FC = () => (
    <div className={css.connectionSteps}>
        <h1>Шаблон договора</h1>
        <DownloadButton file='Лицензионный_договор__v-10.2026_.doc' name='Скачать договор' />
        <p>
            Заполните реквизиты самостоятельно или вышлите карточку компании на info@testograf.ru. Также понадобится
            информация о выбранной лицензии, количестве пользователей и формате работы (в отдельных или общем Личном
            кабинете).
        </p>
        <p>Останется:</p>
        <ul className={css.steps}>
            <li className={css.step}>
                <SuccessMark />
                <p>Выставить счет (самостоятельно в ЛК или нашей командой)</p>
            </li>
            <li className={css.step}>
                <SuccessMark />
                <p>Оплатить счет</p>
            </li>
            <li className={css.step}>
                <SuccessMark />
                <p>Проверить срок действия лицензии в ЛК (доступ будет открыт в момент поступления оплаты)</p>
            </li>
            <li className={css.step}>
                <SuccessMark />
                <p>Приступить к работе</p>
            </li>
            <li className={css.step}>
                <SuccessMark />
                <p>Если есть вопросы - мы на info@testograf.ru</p>
            </li>
        </ul>
    </div>
);
